interface Props {
    text: string,
    onClick: () => void,
    pointer?: boolean,
    fontSize?: number,
    uppercase?: boolean,
}

const WhiteButton: React.FC<Props> = ({
    text,
    onClick,
    pointer = true,
    fontSize = 14,
    uppercase = true,
}) => {
    return (
        <button
            className={`w-full h-full border-none rounded-[5px] font-bold text-black ${pointer && "cursor-pointer"} ${uppercase && "uppercase"} text-[${fontSize}px]`}
            onClick={onClick}
        >
            {text}
        </button>
    )
}

export default WhiteButton
